export const ADD_CUSTOMER = 'Add Customer';

export const SELECT_OPTIONS: string[] = ['Name', 'Phone'];
